import {ssrGetGamesListingById} from '~/graphql/operations/games-listing/games-listing-query.generated';

export async function getDataGame(locale: string) {
  const id: any = '3I8XiNPKEe6K4TlE1eUL8m';
  const {
    props: {data},
  } = await ssrGetGamesListingById.getServerPage(
    {
      variables: {
        id,
        locale,
      },
    },
    {}
  );
  return data.gamesListing?.listItemCollection?.items ?? [];
}
